import { c as _c } from "react/compiler-runtime";
import { Hint, LocaleEnum } from '@systemeio/ui';
import FormSenderEmailInput from 'modules/email/components/form-sender-email-input';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { useSubstituteEmails } from '../hooks/use-substitute-emails';
const getHelpArticleLink = (locale?: LocaleEnum) => {
  switch (locale) {
    case LocaleEnum.DUTCH:
      return 'https://help-nl.systeme.io/article/1394-is-het-mogelijk-om-een-prive-e-mailadres-te-gebruiken-om-e-mails-te-verzenden-vanuit-systeme-io';
    case LocaleEnum.DEUTSCH:
      return 'https://help-de.systeme.io/article/1766-ist-es-moglich-eine-private-e-mail-adresse-zu-verwenden-um-e-mails-von-systemeio-zu-versenden';
    case LocaleEnum.PORTUGUESE:
      return 'https://help-pt.systeme.io/article/743-e-possivel-usar-um-endereco-de-email-particular-para-enviar-emails-na-systeme-io';
    case LocaleEnum.ITALIAN:
      return 'https://help-it.systeme.io/article/478-non-posso-usare-un-indirizzo-yahoo-per-inviare-le-mie-e-mail';
    case LocaleEnum.JAPANESE:
      return 'https://help-jp.systeme.io/article/2410-is-it-possible-to-use-a-private-email-address-to-send-emails-from-systemeio';
    case LocaleEnum.CHINESE:
      return 'https://help-zh.systeme.io/article/3218-is-it-possible-to-use-a-private-email-address-to-send-emails-from-systeme-io';
    case LocaleEnum.ARABIC:
      return 'https://help-ar.systeme.io/article/2731-is-its-possible-to-use-private-email-address-to-send-emails-from-systeme-io';
    case LocaleEnum.FRENCH:
      return 'https://aide.systeme.io/article/29-est-il-possible-utiliser-une-adresse-email-personnelle-pour-envoyer-des-emails-sur-systemeio';
    case LocaleEnum.SPANISH:
      return 'https://help-es.systeme.io/article/878-no-puedo-usar-una-direccion-de-correo-electronico-de-gmail-yahoo-para-enviar-mis-correos-electronicos';
    case LocaleEnum.HINDI:
      return 'https://help-hi.systeme.io/article/3264-is-it-possible-to-use-a-private-email-address-to-send-emails-from-systeme-io';
    default:
      return 'https://help.systeme.io/article/272-is-it-possible-to-use-a-private-email-address-to-send-emails-from-systemeio';
  }
};
namespace SenderEmailInput {
  export interface Props {
    value: string;
    onChange: (value: string) => void;
    error?: string;
    disabled?: boolean;
  }
}
export function SenderEmailInput(t0) {
  const $ = _c(21);
  const {
    value,
    onChange,
    error,
    disabled
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const {
    substituteEmails
  } = useSubstituteEmails();
  const userAccountEmail = user?.mainUser?.user.email || "";
  const substituteEmail = value ? substituteEmails?.[value] : substituteEmails?.[userAccountEmail];
  let t1;
  if ($[0] !== substituteEmail || $[1] !== t || $[2] !== user?.dashboardLocale) {
    t1 = substituteEmail ? <TransLoco t={t} i18nKey="dashboard.settings.mailing.sender_email.description" values={{
      substituteEmail
    }} components={{
      a: <a href={getHelpArticleLink(user?.dashboardLocale)} target="_blank" rel="noopener noreferrer" className="primary-link" />,
      b: <span className="text-brand-primary" />
    }} /> : undefined;
    $[0] = substituteEmail;
    $[1] = t;
    $[2] = user?.dashboardLocale;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("dashboard.settings.mailing.sender_email_address_popover_title");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("dashboard.settings.mailing.sender_email_address_title");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <Hint label={t2}>{t3}</Hint>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== onChange) {
    t5 = e => onChange(e.target.value);
    $[11] = onChange;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== disabled || $[14] !== error || $[15] !== t1 || $[16] !== t4 || $[17] !== t5 || $[18] !== userAccountEmail || $[19] !== value) {
    t6 = <FormSenderEmailInput descriptionClassName="text-text-primary opacity-100" description={t1} labelClassName="text-text-primary" placeholder={userAccountEmail} label={t4} value={value} onChange={t5} error={error} disabled={disabled} />;
    $[13] = disabled;
    $[14] = error;
    $[15] = t1;
    $[16] = t4;
    $[17] = t5;
    $[18] = userAccountEmail;
    $[19] = value;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
}